import { ActionNodeActionProxy } from '..'

import { KickAction } from './KickAction'
import ChannelsInfoHelper from '../../../../../../Helpers/ChannelsInfoHelper'

export class KickActionProxy extends ActionNodeActionProxy {
  action: KickAction

  errorTargets: Array<any> = []

  constructor(action: KickAction) {
    super()

    action.targets.forEach(t => {
      const target = ChannelsInfoHelper.GetChannel(t!.toString())

      if (!target?.status) {
        this.errorTargets.push(t!.toString())
      }
    })

    this.action = action
  }

  getModel(): KickAction {
    return this.action
  }

  removeTarget(id:number) {
    this.action.targets = this.action.targets.filter(t => t !== id)
  }

  removeErrorTarget(value: string) {
    this.errorTargets = this.errorTargets.filter(target => target !== value)
  }

  setErrorTarget(data:any) {
    this.errorTargets.push(data)
  }

  setToTargets(target: number): void {
    this.action.targets.push(target)
  }

  isActionValid(): boolean {
    return this.action.targets.length > 0
  }
}
